'use client';

import { SignUp } from '@clerk/nextjs';

export function SignUpClient({ redirectUrl }: { redirectUrl: string }) {
	return <SignUp forceRedirectUrl={redirectUrl} signInForceRedirectUrl={redirectUrl} />;
}
